module.exports = __webpack_public_path__ + "static/media/add exam details.426ffcc1.svg";